import React from 'react';

import BusinessDetailsTable from '../../../../../components/Table/BusinessDetailsTable';

const BusinessDetailsNew: React.FC = () => {
  return <BusinessDetailsTable />;
};

export default BusinessDetailsNew;
